import React from "react";
import Image from "next/image";
import IMAGES from "@/public/assets/img";



const EligibilityCriteria = ({eligibilityCriteria}) => {
    
  return ( 
    
    <section className="py-20 sm:py-[40px] bg-[url('/assets/img/business-loans/eligibility-bg.webp')] w-full bg-cover bg-no-repeat m-auto h-full">
      <div className="mx-auto w-full container px-3 md:py-2 xm:py-2 md:px-3">
        <div className="max-w-[1280px] mx-auto w-full">
            <div className="flex justify-center gap-x-5 sm:gap-0 sm:flex-col mx-auto w-full">
                <div className="w-full sm:w-full">
                    <h2 className="text-xxl text-white text-center font-bold mb-5">
                      Eligibility Criteria
                    </h2>
                    <div className="flex flex-wrap gap-x-5 sm:gap-0 sm:flex-col mx-auto w-full">
                    {eligibilityCriteria?.map((items) => {
                        return (
                        <div className="w-[48%] sm:w-full mb-5 bg-white p-[20px] rounded-[8px]" key={items?.id}>
                          <h3 className="text-base2 text-[#1A1A1A] font-bold mb-1">
                              {items?.heading}
                          </h3>
                          <p className="text-base text-[#3C3C3C]">
                            {items?.description}
                          </p>
                        </div>
                        );
                    })}
                    </div>
                </div>
            </div>
          </div>
      </div> 
    </section>
  );
};

export default EligibilityCriteria;
